(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('MacroDetailController', MacroDetailController);

    MacroDetailController.$inject = ['$stateParams', '$state', 'entity', '$uibModal', 'Macro'];

    function MacroDetailController($stateParams, $state, entity, $uibModal, Macro) {
        var vm = this;
        vm.macro = [];
        vm.edit = false;
        vm.isGreengrassMacro = false;
        vm.greengrassCommands = [];

        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.macro = entity;

                // Check if it's a Greengrass macro
                vm.isGreengrassMacro = !vm.macro.macroActions || vm.macro.macroActions.length === 0;

                if (vm.isGreengrassMacro) {
                    console.log('Loading Greengrass macro details for:', vm.macro.id);
                    loadGreengrassCommands();
                } else {
                    // Traditional macro
                    vm.macro.macroActions.sort(function (a, b) {
                        var commandA = a.order, commandB = b.order;
                        return commandA - commandB;
                    });
                }
            });
        }

        function loadGreengrassCommands() {
            Macro.getMacroDetails({macroId: vm.macro.id}, function(queueCommands) {
                console.log('Greengrass commands loaded:', queueCommands);

                vm.greengrassCommands = queueCommands.map(function(cmd) {
                    var parsedCmd = angular.copy(cmd);
                    try {
                        if (cmd.arguments && cmd.arguments !== '{}') {
                            parsedCmd.argumentMap = JSON.parse(cmd.arguments);
                        }
                    } catch (e) {
                        console.error('Error parsing arguments:', e);
                    }
                    return parsedCmd;
                });

                // Sort by order
                vm.greengrassCommands.sort(function(a, b) {
                    return a.order - b.order;
                });

                console.log('Processed Greengrass commands:', vm.greengrassCommands);
            }, function(error) {
                console.error('Error loading Greengrass commands:', error);
            });
        }

        vm.deleteMacroAction = function (actionId) {
            $uibModal.open({
                templateUrl: 'app/entities/macro/macro-actions-delete-dialog.html',
                controller: 'MacroActionsDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: ['MacroActions', function (MacroActions) {
                        return MacroActions.get({id: actionId});
                    }]
                }
            }).result.then(function () {
                if(vm.macro.macroActions.length == 1){
                    Macro.delete({id: vm.macro.id});
                    $state.go('macros');
                } else {
                    $state.go('macro-detail', null, {reload: true});
                }
            }, function () {
                $state.go('macro-detail');
            });
        }

        vm.deleteGreengrassCommand = function(index) {
            var command = vm.greengrassCommands[index];

            $uibModal.open({
                templateUrl: 'app/entities/macro/macro-actions-delete-dialog.html',
                controller: 'MacroActionsDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function() {
                        return {
                            id: command.id,
                            commandName: command.commandName,
                            macroId: vm.macro.id,
                            isLastCommand: vm.greengrassCommands.length === 1,
                            isGreengrass: true
                        };
                    }
                }
            }).result.then(function () {
                // Check if we need to navigate away (macro was deleted)
                if (vm.greengrassCommands.length === 1) {
                    $state.go('macros');
                } else {
                    $state.go('macro-detail', null, {reload: true});
                }
            }, function () {
                // User cancelled or error, stay on page
            });
        }

        vm.moveUp = function(index) {
            var command = vm.macro.macroActions[index];
            vm.macro.macroActions.splice(index, 1);
            vm.macro.macroActions.splice(index - 1, 0, command);
            vm.edit = true;
        }

        vm.moveDown = function(index) {
            var command = vm.macro.macroActions[index];
            vm.macro.macroActions.splice(index, 1);
            vm.macro.macroActions.splice(index + 1, 0, command);
            vm.edit = true;
        }

        vm.moveUpGreengrass = function(index) {
            var command = vm.greengrassCommands[index];
            vm.greengrassCommands.splice(index, 1);
            vm.greengrassCommands.splice(index - 1, 0, command);
            vm.edit = true;
        }

        vm.moveDownGreengrass = function(index) {
            var command = vm.greengrassCommands[index];
            vm.greengrassCommands.splice(index, 1);
            vm.greengrassCommands.splice(index + 1, 0, command);
            vm.edit = true;
        }

        vm.save = function () {
            if (vm.isGreengrassMacro) {
                console.log('Saving Greengrass macro order');
                console.log('Commands to update:', vm.greengrassCommands);

                // Send update request using the service
                Macro.updateGreengrassCommandsOrder({
                    macroId: vm.macro.id
                }, vm.greengrassCommands, function(response) {
                    console.log('Order updated successfully');
                    vm.edit = false;
                    $state.go('macro-detail', null, {reload: true});
                }, function(error) {
                    console.error('Error updating order:', error);
                    alert('Error saving changes: ' + (error.data.message || 'Unknown error'));
                });
            } else {
                // Traditional macro save
                for(var i = 0; i < vm.macro.macroActions.length; i++){
                    vm.macro.macroActions[i].order = i + 1;
                }

                Macro.update(vm.macro, onSuccess, onError);
            }

            function onSuccess() {
                vm.edit = false;
                $state.go('macro-detail', null, {reload: true});
            }

            function onError() {
                console.error('Error saving macro');
            }
        }
    }
})();
